import React from "react";
import { ShieldCheck, Smartphone, Check } from "lucide-react";

export default function AboutModern() {
  return (
    <section
      id="about"
      className="section-white"
      style={{
        paddingTop: "90px",
        paddingBottom: "90px",
      }}
    >
      <div className="container">
        <div className="row align-items-center">
          {/* Left Column: Heading & Company Narrative */}
          <div className="col-lg-6 mb-5 mb-lg-0">
            <span className="badge-label mb-2">About</span>

            <h2
              className="section-title"
              style={{
                marginTop: "8px",
                marginBottom: "16px",
              }}
            >
              Built to simplify <br />
              financial operations.
            </h2>

            <p
              style={{
                fontSize: "1.05rem",
                lineHeight: 1.65,
                color: "#475569",
                marginBottom: "20px",
              }}
            >
              EMIBOOK is an EMI and loan management system created by <strong>S R R Enterprise</strong>,
              designed for streamlining loans, empowering financial lenders, and safe-keeping investments.
              We replace physical registers and fragmented bookkeeping with a unified, secure mobile experience.
            </p>

            <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              <div style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
                <div
                  style={{
                    width: "22px",
                    height: "22px",
                    borderRadius: "50%",
                    backgroundColor: "rgba(37, 99, 235, 0.1)",
                    color: "#2563eb",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    marginTop: "2px",
                  }}
                >
                  <Check size={13} />
                </div>
                <div>
                  <strong style={{ color: "#0f172a", fontSize: "0.92rem" }}>Secure Loan & EMI Histories:</strong>
                  <p style={{ color: "#64748b", fontSize: "0.88rem", margin: 0 }}>
                    Securely provide loans and track repayment transaction histories on dedicated mobile apps.
                  </p>
                </div>
              </div>

              <div style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
                <div
                  style={{
                    width: "22px",
                    height: "22px",
                    borderRadius: "50%",
                    backgroundColor: "rgba(37, 99, 235, 0.1)",
                    color: "#2563eb",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    marginTop: "2px",
                  }}
                >
                  <Check size={13} />
                </div>
                <div>
                  <strong style={{ color: "#0f172a", fontSize: "0.92rem" }}>Organized Digital Hub:</strong>
                  <p style={{ color: "#64748b", fontSize: "0.88rem", margin: 0 }}>
                    Say goodbye to complex tracking and hello to an organized digital solution that fits right in your pocket.
                  </p>
                </div>
              </div>

              <div style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
                <div
                  style={{
                    width: "22px",
                    height: "22px",
                    borderRadius: "50%",
                    backgroundColor: "rgba(37, 99, 235, 0.1)",
                    color: "#2563eb",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    marginTop: "2px",
                  }}
                >
                  <Check size={13} />
                </div>
                <div>
                  <strong style={{ color: "#0f172a", fontSize: "0.92rem" }}>Collections & Overdue Visibility:</strong>
                  <p style={{ color: "#64748b", fontSize: "0.88rem", margin: 0 }}>
                    See what has been collected and what has slipped past its due date, without chasing paperwork.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column: Clean White Brand Highlight Card */}
          <div className="col-lg-6">
            <div
              className="card-clean"
              style={{
                borderRadius: "24px",
                padding: "32px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  marginBottom: "24px",
                  paddingBottom: "16px",
                  borderBottom: "1px solid #f1f5f9",
                }}
              >
                <img
                  src="assets/1024.png"
                  alt="EMIBOOK"
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "10px",
                  }}
                />
                <div>
                  <h4 style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: "1.15rem", margin: 0, color: "#0f172a" }}>
                    EMIBOOK Platform
                  </h4>
                  <span style={{ fontSize: "0.8rem", color: "#64748b" }}>
                    A venture by S R R Enterprise
                  </span>
                </div>
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "14px",
                  marginBottom: "20px",
                }}
              >
                <div
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    borderRadius: "14px",
                    padding: "16px",
                  }}
                >
                  <div style={{ color: "#2563eb", marginBottom: "6px" }}>
                    <ShieldCheck size={20} />
                  </div>
                  <div style={{ fontFamily: "var(--font-display)", fontSize: "1rem", fontWeight: 700, color: "#0f172a" }}>
                    Secure Records
                  </div>
                  <span style={{ color: "#64748b", fontSize: "0.78rem" }}>Loans, payments & receipts</span>
                </div>

                <div
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    borderRadius: "14px",
                    padding: "16px",
                  }}
                >
                  <div style={{ color: "#059669", marginBottom: "6px" }}>
                    <Smartphone size={20} />
                  </div>
                  <div style={{ fontFamily: "var(--font-display)", fontSize: "1rem", fontWeight: 700, color: "#0f172a" }}>
                    Android App
                  </div>
                  <span style={{ color: "#64748b", fontSize: "0.78rem" }}>Manage the book on the go</span>
                </div>
              </div>

              <div
                style={{
                  background: "#eff6ff",
                  border: "1px solid #bfdbfe",
                  borderRadius: "14px",
                  padding: "14px 18px",
                  fontSize: "0.85rem",
                  color: "#1e3a8a",
                  fontWeight: 500,
                }}
              >
                Direct Support: <strong>support@emibook.in</strong> • <strong>+91 9036770772</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
